import React from 'react';

const CatalogoProductosSpcPremium = () => {
  return (
    <section>
      <div className="container">
        <div className="title-style2 text-center mb-2-2 wow fadeIn" data-wow-delay="200ms">
          <h2 className="h1">Catálogo Modelos Piso SPC Luxury</h2>
        </div>
        <div className="row mt-n1-9">
          {/* Producto 1 */}
          <Producto
            imgSrc="/assets/img/productos/pisos-spc-premium/MARMOL/img0.jpg"
            altText="Piso SPC catalogo LQ8105-1"
            codigo="MARMOL BLANCO"
            tipo="Piso SPC Luxury"
            delay="100ms"
          />
          {/* Producto 2 */}
          <Producto
            imgSrc="/assets/img/productos/pisos-spc-premium/NOGAL/img0.jpg"
            altText="piso spc luxury catalogo 40062-8"
            codigo="NOGAL"
            tipo="Piso SPC Luxury"
            delay="200ms"
          />
          {/* Producto 3 */}
          <Producto
            imgSrc="/assets/img/productos/pisos-spc-premium/GRIS/img0.jpg"
            altText="piso luxury catalogo 2010-18"
            codigo="GRIS"
            tipo="Piso SPC Luxury"
            delay="300ms"
          />
          {/* Producto 4 */}
          <Producto
            imgSrc="/assets/img/productos/pisos-spc-premium/MARFIL/img0.jpg"
            altText="piso spc luxury catalogo 33038-022"
            codigo="MARFIL"
            tipo="Piso SPC Luxury"
            delay="400ms"
          />
        </div>
      </div>
    </section>
  );
};

// Componente para cada producto
const Producto = ({ imgSrc, altText, codigo, tipo, delay }) => {
  const imgContainerStyle = {
    height: '400px',
    overflow: 'hidden',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    backgroundColor: '#f8f9fa'
  };

  const imgStyle = {
    width: '100%',
    height: '100%',
    objectFit: 'cover',
    display: 'block'
  };

  return (
    <div className={`col-sm-6 col-lg-3 mt-1-9 wow fadeInUp`} data-wow-delay={delay}>
      <div className="card card-style3 border-0 text-center h-100">
        <div className="card-img position-relative" style={imgContainerStyle}>
          <img src={imgSrc} className="card-img-top" alt={altText} style={imgStyle} />
        </div>
        <div className="card-body p-1-9">
          <h3 className="h5">{codigo}</h3>
          <p className="text-primary mb-0">{tipo}</p>
        </div>
      </div>
    </div>
  );
};

export default CatalogoProductosSpcPremium;
